import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import getCurrencySymbol, { getCountryInfo } from '../lib/currenyUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BeneficiaryDetail from './Beneficiaries/BeneficiaryDetail';

function SendMoneyByBeneficiary() {
  const navigate = useNavigate();
  const { state: paramsdata } = useLocation();

  const workspaces = JSON.parse(sessionStorage.getItem('login_workspaces'));
  const account_type = workspaces?.[0]?.type;

  const transferflowamount = paramsdata?.transferflowamount;
  const currencyid = paramsdata?.currencyid;
  const selectedcurrency = paramsdata?.currency;

  const bene_type = paramsdata?.accountType;
  const selectedbeneficiary = paramsdata?.selectedBeneficiary;
  const selectedbeneficiaryCode = paramsdata?.selectedbeneficiaryCode;
  const selectedbeneficiaryBankAccoutNumber = paramsdata?.selectedbeneficiaryBankAccoutNumber;
  const selectedbeneficiaryType = paramsdata?.selectedbeneficiaryType;
  const selectedbeneficiaryId = paramsdata?.selectedbeneficiaryId;
  const selectedbeneficiaryCountry = paramsdata?.selectedbeneficiaryCountry;
  const selectedbeneficiaryBankAccountId = paramsdata?.selectedbeneficiaryBankAccountId;
  const selectedbene_type = paramsdata?.selectedbene_type;
  const selectedbank_type = paramsdata?.selectedbank_type;
  const balanceAmount = paramsdata?.balanceAmount;
  const selectedbeneficiaryAddress = paramsdata?.selectedbeneficiaryAddress;
  const selectedbeneficiaryPaymentType = paramsdata?.selectedbeneficiaryPaymentType;
  const selectedbeneficiaryMeta = paramsdata?.selectedbeneficiaryMeta; 

  const [amount, setAmount] = useState('');
  const [balance, setBalance] = useState('');
  const [currency, setCurrency] = useState('');
  const [loading, setLoading] = useState(false);

  const finalCurrency = selectedcurrency || currency;

  useEffect(() => {
    if (transferflowamount) {
      setAmount(transferflowamount);
      sessionStorage.setItem('receive', JSON.stringify(currencyid));
    }
    if (currencyid) {
      getBalances();
    }
  }, [currencyid]);

  const proceedToPay = () => {
    if (!amount || amount <= 0) {
      toast.error('Please enter a valid amount');
      return;
    }
    if (Number(balance) < Number(amount)) {
      toast.error('Insufficient Funds.');
      return;
    }
    navigate('/PaymentConfirmation', {
      state: {
        name: selectedbeneficiary,
        ifsc: selectedbeneficiaryCode,
        account: selectedbeneficiaryBankAccoutNumber,
        type: selectedbeneficiaryType,
        id: selectedbeneficiaryId,
        bank_account_name: selectedbeneficiary,
        currencyid,
        currency: finalCurrency,
        amount,
        bank_account_id: selectedbeneficiaryBankAccountId,
        country: selectedbeneficiaryCountry,
        bene_type: selectedbene_type,
        bank_type: selectedbank_type,
      },
    });
  };

  const getBalances = async () => {
    setLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        `${Constants.BASE_URL}API-FX-231-GET-WALLET-BALANCES/${login_workspaces_id}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(login_token)}`,
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const usedBalance = resp.data.used_balances;
      const balances = Object.values(resp.data).filter((b) => b?.meta?.country_id);
      balances.find((b) => {
        if (b.meta.country_id == currencyid) {
          const available = b.balance - (usedBalance?.[b.currency] ?? 0);
          setBalance(available < 0 ? '0.00' : parseFloat(available).toFixed(2));
          setCurrency(b.currency);
        }
      });
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const isReady = selectedbeneficiary && amount;

  return (
    <div style={styles.page}>
      <ToastContainer />

      <div style={styles.centerCol}>
      <div style={{ fontSize: 24, fontWeight: 700, color: '#394784', textAlign: 'center', marginBottom: 18 }}>
          Beneficiary Details
        </div>
        {/* Top Card — currency + amount + proceed */}
        <div style={styles.topCard}>

          {/* Currency Row */}
          <div style={styles.currencyRow}>
            {loading ? (
              <div style={{ fontSize: '13px', color: '#94a3b8' }}>Loading...</div>
            ) : (
              <>
                {finalCurrency && (
                  React.isValidElement(getCountryInfo(finalCurrency)?.flag)
                    ? getCountryInfo(finalCurrency).flag
                    : (
                      <img
                        src={getCountryInfo(finalCurrency)?.flag}
                        alt="flag"
                        style={styles.flag}
                        onError={(e) => (e.target.src = '/flags/default.png')}
                      />
                    )
                )}
                <span style={styles.currencyCode}>{finalCurrency}</span>
                {account_type === 'business' && (
                  <span style={styles.currencyBalance}>
                    ({getCurrencySymbol(finalCurrency)} {balance || balanceAmount})
                  </span>
                )}
              </>
            )}
          </div>

          {/* Amount Input */}
          <div style={styles.amountInputWrapper}>
            <span style={styles.currencyPrefix}>{getCurrencySymbol(finalCurrency)}</span>
            <input
              type="number"
              min="0"
              value={amount}
              placeholder="Enter Amount"
              style={{
                ...styles.amountInput,
                fontWeight: amount ? 700 : 400,
                color: amount ? '#1D2338' : '#8F959F',
              }}
              onFocus={(e) => { e.target.style.borderColor = '#0B214E'; }}
              onBlur={(e) => { e.target.style.borderColor = '#E2E6ED'; }}
              onChange={(e) => {
                const val = e.target.value;
                if (val === '') { setAmount(''); return; }
                const validated = val.match(/^(\d*\.{0,1}\d{0,2}$)/);
                if (validated) { setAmount(Math.abs(validated[0])); }
              }}
            />
          </div>

        </div>

        {/* Proceed Button */}
        <button
          onClick={proceedToPay}
          disabled={!selectedbeneficiary || !amount}
          style={{
            ...styles.proceedBtn,
            background: isReady ? '#D26521' : '#D1D5DB',
            cursor: isReady ? 'pointer' : 'not-allowed',
          }}
          onMouseEnter={(e) => { if (isReady) e.currentTarget.style.opacity = '0.88'; }}
          onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
        >
          Proceed →
        </button>

        {/* Back Button */}
        <div
          style={styles.backBtn}
          onClick={() => navigate(-1)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
            <path
              d="M19 12H5M5 12L11 18M5 12L11 6"
              stroke="#676F7D"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span style={styles.backText}>Back</span>
        </div>

        {/* Beneficiary Detail Card */}
        <BeneficiaryDetail
          beneficiary={{
            display_name: selectedbeneficiary,
            bank_account_number: selectedbeneficiaryBankAccoutNumber,
            iban: '',
            type: selectedbeneficiaryType,
            country: selectedbeneficiaryCountry,
            currency: finalCurrency,
            code: selectedbeneficiaryCode,
            bene_type: bene_type,
            address: selectedbeneficiaryAddress,
            payment_type: selectedbeneficiaryPaymentType,
            meta: selectedbeneficiaryMeta,
          }}
          hideBackButton
          hideDeleteButton
          fullWidth
        />

      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    padding: '32px 40px 40px',
    boxSizing: 'border-box',

    display: 'flex',
    justifyContent: 'center',

    backgroundColor: '#ffffff',
    backgroundImage: `
      linear-gradient(
        180deg,
        rgba(248, 250, 252, 1) 0%,
        rgba(239, 246, 255, 0.3) 50%,
        rgba(238, 242, 255, 0.4) 100%
      )
    `,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },

  centerCol: {
    width: '100%',
    maxWidth: '720px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  topCard: {
    width: '640px',
    background: '#FFFFFF',
    borderRadius: '12px',
    border: '1px solid #F2F2F2',
    boxShadow: '0px 4px 16px -4px rgba(0, 0, 0, 0.06)',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '16px',
    boxSizing: 'border-box',
  },

  currencyRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    height: '32px',
    width: '100%',
  },

  flag: {
    width: 32,
    height: 22,
    objectFit: 'cover',
    borderRadius: 3,
    flexShrink: 0,
  },

  currencyCode: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 15,
    fontWeight: 700,
    color: '#1D2338',
  },

  currencyBalance: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 15,
    fontWeight: 400,
    color: '#1D2338',
  },

  amountInputWrapper: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  currencyPrefix: {
    position: 'absolute',
    left: '16px',
    fontSize: '15px',
    fontWeight: 500,
    color: '#9CA3AF',
    pointerEvents: 'none',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    height: '32px',
  },

  amountInput: {
    width: '100%',
    height: '56px',
    borderRadius: '12px',
    border: '1px solid #E2E6ED',
    paddingTop: '12px',
    paddingRight: '16px',
    paddingBottom: '12px',
    paddingLeft: '36px',
    fontSize: '15px',
    fontWeight: 400,
    color: '#8F959F',
    background: '#FFFFFF',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.15s',
  },

  proceedBtn: {
    width: '640px',
    height: '56px',
    borderRadius: '12px',
    border: 'none',
    paddingTop: '12px',
    paddingRight: '20px',
    paddingBottom: '12px',
    paddingLeft: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    boxShadow: '0px 8px 20px 0px #0000001F',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 700,
    color: '#FFFFFF',
    letterSpacing: 0,
    opacity: 1,
    transition: 'opacity 0.15s',
    marginBottom: '28px',
  },

  sectionTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: '#394784',
    textAlign: 'center',
    marginBottom: 18,
    letterSpacing: '0px',
    lineHeight: '100%',
    width: '640px',
  },

  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    marginBottom: 18,
    width: '640px',
    justifyContent: 'flex-start',
  },

  backText: {
    fontSize: 20,
    fontWeight: 700,
    color: '#1D2338',
    lineHeight: '100%',
    letterSpacing: '0px',
  },
};

export default SendMoneyByBeneficiary;